import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    isLoading: false, 
});

export const ProgressContext = ctx;

export const ProgressProvider = Provider;
